import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles(theme => ({
    contextFieldSelect: {
        marginRight: '8px',
    },
}));
